const cardPopup = document.querySelectorAll('.card-popup');

cardPopup.forEach((card) => {
    card.addEventListener('click', () => {
        card.classList.toggle('popup-open');
    })
})
